import { Pipe, PipeTransform } from '@angular/core';
import { WidgetSettings } from 'app/views/dashboard/widgets/widget-settings';

@Pipe({
  name: 'widgetSettings',
})
export class WidgetSettingsPipe implements PipeTransform {
  transform(widgetsSettings: WidgetSettings[], widgetId: string, settingName: string): any {
    const widgetSettings = widgetsSettings.find(e => e.widgetId === widgetId);
    if (widgetSettings) {
      return widgetSettings[settingName];
    } else {
      return null;
    }
  }
}
